import axios from 'axios';
import {
  API_URL,
  SHOW_QUESTIONNAIRE_REVISION,
  QUESTIONNAIRE,
  UPDATE_QUESTIONNAIRE,
  SHOW_QUESTIONNAIRE,
  DELETE_QUESTIONNAIRE,
  DELETE_QUESTIONNAIRE_PASS
} from './ConstantService';

export const QuestionnaireService = {
  deleteWithPassword(id, password) {
    return axios.post(DELETE_QUESTIONNAIRE_PASS.replace('{id}', id), { password });
  },

  getAllByRevision() {
    return axios.get(API_URL + SHOW_QUESTIONNAIRE_REVISION.replace('{id}', id));
  },

  getAll(params = {}) {
    return axios.get(API_URL + QUESTIONNAIRE, { params });
  },

  show(id) {
    return axios.get(API_URL + SHOW_QUESTIONNAIRE.replace('{id}', id));
  },

  update(id, data) {
    return axios.patch(API_URL + UPDATE_QUESTIONNAIRE.replace('{id}', id), data);
  },

  delete(id) {
    return axios.delete(API_URL + DELETE_QUESTIONNAIRE.replace('{id}', id));
  },

  create(data) {
    return axios.post(API_URL + QUESTIONNAIRE, data);
  }
};
